import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import Faqs from '../../elements/Faqs';
import FooterOne from '../../common/footer/FooterOne';

const Faq = () => {
    return (
        <>
        <HeaderOne />
        
        <Faqs />
                
        <FooterOne />
        </>
    )
}

export default Faq ;